import React from 'react';
import { Form } from 'react-final-form';
import PropTypes from 'prop-types';
import { useValidationSchema } from '../../hooks';

export const FxReactFinalFormWrapper = ({
  initialValues,
  validationSchema,
  validationContext,
  onSubmit,
  children,
}) => {
  const validate = useValidationSchema(validationSchema, validationContext);

  return (
    <Form
      validate={validate}
      onSubmit={onSubmit}
      initialValues={initialValues}
      debug={(state, fieldStates) => console.log(state, fieldStates)}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>{children}</form>
      )}
    />
  );
};

FxReactFinalFormWrapper.propTypes = {
  initialValues: PropTypes.shape({}),
  validationSchema: PropTypes.shape({}),
  validationContext: PropTypes.shape({}),
  onSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
};

FxReactFinalFormWrapper.defaultProps = {
  initialValues: {},
  validationSchema: null,
  validationContext: {},
  onSubmit: () => {},
};
